import { render } from "./TextTyping.vue?vue&type=template&id=1b796495&scoped=true"
import script from "./TextTyping.vue?vue&type=script&lang=js"
export * from "./TextTyping.vue?vue&type=script&lang=js"

import "./TextTyping.vue?vue&type=style&index=0&id=1b796495&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b796495"]])

export default __exports__